import React from 'react';
import { Card, CardBody, CardTitle, CardText } from 'reactstrap';

const RegistrarOffice = () => {
    return (
        <div className="container mt-5 mb-5">
            <Card className="shadow border-0 rounded-4">
                <div className="row g-0">
                    <div className="col-md-12">
                        <CardBody className="p-4">
                            <CardTitle tag="h4" className="text-center text-primary fw-bold">
                                कुलसचिव कार्यालय
                            </CardTitle>
                            <hr />
                            <CardText className="mt-3 fs-5">
                                <strong>संपर्क:</strong> 01746-297260<br />
                                <strong>ई-मेल:</strong> <a href="mailto:registrar@mvsu.ac.in">registrar@mvsu.ac.in</a><br />
                                <strong>अस्थाई परिसर:</strong><br />
                                डॉ. भीम राव अम्बेडकर राजकीय महाविद्यालय,<br />
                                जगदीशपुरा, कैथल (हरियाणा) - 136027
                            </CardText>
                        </CardBody>
                    </div>
                </div>
            </Card>
        </div>
    );
};

export default RegistrarOffice;
